'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _adminUserList = require('./admin-user-list.component');

var _adminUserList2 = _interopRequireDefault(_adminUserList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.admin-user-list', []).component('adminUserList', _adminUserList2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/admin-users/admin-user-list/admin-user-list.module.js